'use client';

import { useConversionAttributionCapture } from '../hooks/useConversionAttributionCapture';

/** Renders nothing; hosts the root-owned landing capture inside a Suspense boundary. */
export default function ConversionAttributionCapture() {
  useConversionAttributionCapture();
  return null;
}
